import React, { useState } from "react";
import { telegramAuthOn } from "src/api/securityAuthApi";
import { showErrorToast } from "src/utils/toast";

const TelegramAuth: React.FC = () => {
  const [password, setPassword] = useState<string>("");
  const [stage, setStage] = useState<"password" | "otp">("password");
  const [optRes, setOptRes] = useState<{ telegram_channel: string; telegram_code: string } | null>(null);

  const handleGetConnectionId = () => {
    telegramAuthOn({
      payload: {
        password,
      },
    })
      .then(({ data }) => {
        if (!data?.telegram_code) {
          showErrorToast("Something went wrong while getting connection id");
        }
        setOptRes(data);
        setStage("otp");
      })
      .catch((error) => {
        let message = error?.data?.status_message ?? "Something went wrong";
        if (message === "Invalid login credentials.") {
          message = "User Password Not Valid.";
        }
        showErrorToast(message);
      });
  };

  return (
    <div className="text-center">
      <b>Please enter your login password to continue</b>
      <div className="form-group mt-3 secure-password">
        <input
          type="password"
          placeholder="Enter your login Password"
          className="form-control"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="button" className="btn btn-primary ml-2 vt" disabled={!password} onClick={handleGetConnectionId}>
          Get Connection ID
        </button>
      </div>
      {stage === "otp" && (
        <div className="mt-3">
          <b>Please follow below instructions for the telegram 2-step verification</b>
          <p>
            Find
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://t.me/${optRes?.telegram_channel}?start`}
              className="text-primary"
            >
              {`@${optRes?.telegram_channel}`}
            </a>{" "}
            in your telegram and type
            <kbd>/start</kbd>
            command. Bot will respond you.
          </p>
          <p className="text-dark">
            After this type <kbd>{`/connect ${optRes?.telegram_code}`}</kbd> and send it to BOT.
          </p>
          <p>
            Now your telegram account will be linked with your website account and 2-Step veriication will be enabled.
          </p>
          <hr />
        </div>
      )}
    </div>
  );
};

export default TelegramAuth;
